import type { ReactNode } from 'react';
import './GeneralLayout.css';

export type GeneralLayoutProps = {
  left: ReactNode;
  right: ReactNode;
  className?: string;
  containerClassName?: string;
  leftClassName?: string;
  rightClassName?: string;
  leftHidden?: boolean;
  rightActive?: boolean;
};

export function GeneralLayout({
  left,
  right,
  className,
  containerClassName,
  leftClassName,
  rightClassName,
  leftHidden = false,
  rightActive = false,
}: GeneralLayoutProps) {
  const layoutClassName = ['general-layout', className ?? ''].filter(Boolean).join(' ');
  const containerClasses = ['general-layout__container', containerClassName ?? '']
    .filter(Boolean)
    .join(' ');
  const leftClasses = [
    'general-layout__panel',
    'general-layout__panel--primary',
    leftHidden ? 'general-layout__panel--hidden-mobile' : '',
    leftClassName ?? '',
  ]
    .filter(Boolean)
    .join(' ');
  const rightClasses = [
    'general-layout__panel',
    'general-layout__panel--secondary',
    rightActive ? 'general-layout__panel--active' : '',
    rightClassName ?? '',
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <div className={layoutClassName}>
      <div className={containerClasses}>
        <aside className={leftClasses}>{left}</aside>
        <div className={rightClasses}>{right}</div>
      </div>
    </div>
  );
}

export default GeneralLayout;
